var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeapon3White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9067 63.87L0.106689 50.64C4.21669 46.64 8.60669 42.23 13.1767 38C17.1767 34.3 18.5367 29.7 18.1767 24.49C17.9528 21.2476 18.4217 17.9947 19.5522 14.9476C20.6827 11.9005 22.4488 9.12884 24.7332 6.817C27.0176 4.50517 29.768 2.70608 32.8014 1.53932C35.8348 0.372565 39.0819 -0.135126 42.3267 0.0499979C43.9267 0.149998 45.5167 0.549998 47.8667 0.949998C44.9467 3.88 42.3967 6.51 39.7567 9C37.1167 11.49 34.2767 14.08 31.6667 16.49C32.9367 21.1 34.0267 25.03 35.0867 28.89L47.0167 32.12L62.3767 16.23C64.4867 20.49 64.0567 24.31 63.3167 28.03C61.3767 37.91 52.1067 45.57 41.9667 45.79C40.7167 45.79 39.4667 45.79 38.2167 45.79C35.9049 45.7023 33.601 46.1092 31.4591 46.9835C29.3172 47.8579 27.3867 49.1795 25.7967 50.86C21.5667 55.23 17.2267 59.51 12.9067 63.87Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.81,
    height: 63.87,
    fill: "white",
    transform: "translate(0.106689)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeapon3White);
export default __webpack_public_path__ + "static/media/weapon3_white.8e485d7e2e8c0cbd7e3da3bd70e52447.svg";
export { ForwardRef as ReactComponent };